import apiSlice from "./apiSlice";


const procurementSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllPlanActuaData: builder.query({
            query: (req) => ({
                url: `procurement/material_plan-vs-actual-kpi`,
                params: req,
            }),
        }),

        getAllScurveData: builder.query({
            query: (req)=> ({
                url: `procurement/progress-curve`,   
                params: req,
            })
        })

    }),
});

export const { useGetAllPlanActuaDataQuery, useGetAllScurveDataQuery } = procurementSlice;